/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

function getMipmap(src, res) {
    var imgblocks = src.split("/");
    var imgfile = imgblocks[imgblocks.length - 1];
    var thumbnailimgsmall =
        imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
    imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
    return imgblocks.join("/");
}